// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The denial surfaces: a page-level notice that stands in for content the
   caller cannot read, and the modal a guarded action opens instead of acting.
   Both are informational, not error states — they use the muted card
   treatment rather than the red one, because being told what you don't have
   is not a failure. */

.permission-denied-notice {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 24px;
  border: 1px solid var(--border-color, rgba(128, 128, 128, 0.3));
  border-radius: 8px;
  background: var(--card-background, transparent);
}

.permission-denied-notice-heading {
  margin: 0 0 4px 0;
}

.permission-denied-notice-icon {
  opacity: 0.55;
  margin-bottom: 4px;
}

.permission-denied-notice-message {
  margin: 0;
  font-weight: 600;
}

.permission-denied-notice-hint {
  margin: 0;
}

.permission-denied-notice-requirement {
  font-family: var(--font-mono, monospace);
  white-space: nowrap;
}

.permission-denied-modal-message {
  margin: 0 0 10px 0;
  font-weight: 600;
  text-align: left;
}

.permission-denied-modal-hint {
  margin: 0;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/permissions/permission-denied.css"],"names":[],"mappings":"AAAA;;;;sBAIsB;;AAEtB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,+DAA+D;EAC/D,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB","sourcesContent":["/* The denial surfaces: a page-level notice that stands in for content the\n   caller cannot read, and the modal a guarded action opens instead of acting.\n   Both are informational, not error states — they use the muted card\n   treatment rather than the red one, because being told what you don't have\n   is not a failure. */\n\n.permission-denied-notice {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 24px;\n  border: 1px solid var(--border-color, rgba(128, 128, 128, 0.3));\n  border-radius: 8px;\n  background: var(--card-background, transparent);\n}\n\n.permission-denied-notice-heading {\n  margin: 0 0 4px 0;\n}\n\n.permission-denied-notice-icon {\n  opacity: 0.55;\n  margin-bottom: 4px;\n}\n\n.permission-denied-notice-message {\n  margin: 0;\n  font-weight: 600;\n}\n\n.permission-denied-notice-hint {\n  margin: 0;\n}\n\n.permission-denied-notice-requirement {\n  font-family: var(--font-mono, monospace);\n  white-space: nowrap;\n}\n\n.permission-denied-modal-message {\n  margin: 0 0 10px 0;\n  font-weight: 600;\n  text-align: left;\n}\n\n.permission-denied-modal-hint {\n  margin: 0;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
